import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import withStyles from '@material-ui/core/styles/withStyles';
import { withRouter } from 'react-router-dom';
import { isTablet } from 'react-device-detect';
import { v4 as uuidv4 } from 'uuid';
import { safeRefIn } from 'utils/utils';

import { getLogger } from 'utils/logger';

import NestedQMenu from 'components/NestedQMenu';
import QTip from 'components/QuickenControls/QTip';
import QIconButton from 'components/QIconButton';
import QTypography from 'components/MUIWrappers/QTypography';

import TextField from '@material-ui/core/TextField';
import ExpandMoreRoundedIcon from '@material-ui/icons/ExpandMoreRounded';
import ExpandLessRoundedIcon from '@material-ui/icons/ExpandLessRounded';
import CircularProgress from '@material-ui/core/CircularProgress';

import { getMostPopularCatsByAccountId } from 'data/transactions/selectors';
import { getChartOfAccountsTree, getTransferCOATree } from 'data/chartOfAccounts/selectors';
import { getCoaId, isTransferCoaNotFound, TRANSFER_NOT_FOUND_COA_ID } from 'data/chartOfAccounts/utils';
import { getAccountsById } from 'data/accounts/selectors';
import { getCoaString } from 'data/categories/retrievers';
import { getCategoriesById } from 'data/categories/selectors';

import { mkCategory, CategoryTypeEnum } from 'data/categories/types';
import { createCategory } from 'data/categories/actions';
import { CoaTypeEnum } from 'data/chartOfAccounts/types';
import { coaIncludedInList } from '../helpers';

const log = getLogger('components/QuickenControls/CategoryFieldEditable/index.js');
const isIe = require('is-iexplorer');

class CategoryFieldEditable extends PureComponent {

  constructor(props) {
    super(props);

    const coaId = getCoaId(props.value, props.allowBlank); // allow blank
    const coaNode = this.getCoaNode(coaId, props);

    this.state = {
      tfValue: coaId === 'BLANK' ? '' : this.getDisplayName(coaNode),
      isTransfer: this.isTransfer(coaNode),
      query: null,
      showMenu: false,
      placeholder: null,
      inProgress: false,
    };
    this.currentHover = null;
    this.inputRef = null;
    this.fieldRef = undefined;
  }

  componentDidMount() {
    if (this.props.initialFocus && this.inputRef) {
      this.inputRef.focus();
    }
    if (this.props.openMenu) {
      this.setState({ showMenu: true });
    }
  }

  componentWillReceiveProps(nextProps) {

    if (nextProps.coaNodesById) {
      if (nextProps.value !== this.props.value
        || nextProps.coaNodesById !== this.props.coaNodesById
        || nextProps.longCats !== this.props.longCats) {

        const coaId = getCoaId(nextProps.value, nextProps.allowBlank);
        const coaNode = this.getCoaNode(coaId, nextProps);
        // todo: if coaNode cannot be found, set it to uncategorized coaNode

        if (coaNode) {
          this.setState({ isTransfer: this.isTransfer(coaNode), tfValue: this.getDisplayName(coaNode, nextProps) });
        } else {
          this.setState({ isTransfer: false, tfValue: '' });
        }

        if (!this.props.value ||
          (this.inputRef && safeRefIn(nextProps, ['value', 'id']) !== safeRefIn(this.props, ['value', 'id']))) {
          if (this.inputRef && this.props.autoFocus) {
            if (isTablet) {
              setTimeout(() => {
                if (this.inputRef) {
                  this.inputRef.focus();
                  this.inputRef.select();
                }
              }, 250);
            } else {
              this.inputRef.focus();
              this.inputRef.select();
            }
          }
        }
      }
    }
  }

  componentDidUpdate(prevProps) {
    const { state, props } = this;
    if (prevProps.categoriesById !== props.categoriesById && state.newCategoryClientId) {
      const newCategoryCreated = props.categoriesById.find((category) => category.clientId === state.newCategoryClientId);
      if (newCategoryCreated) {
        const newNode = props.coaNodesById.get(newCategoryCreated.id);
        const newCOA = newNode && newNode.coa;
        if (newCOA) {
          this.setState({ // eslint-disable-line react/no-did-update-set-state
            newCategoryClientId: undefined,
            inProgress: false,
          });
          props.onChange(newCOA);
        }
      }
    }
  }

  getCoaNode = (coaId, props) => {
    let ret = props.coaNodesById ? props.coaNodesById.get(coaId) : null;

    if (isTransferCoaNotFound(props.value)) {
      ret = props.coaNodesById.get(TRANSFER_NOT_FOUND_COA_ID);
    }
    return ret;
  };

  getDisplayName = (node, props = this.props) => {
    if (node) {
      return props.longCats ? node.fullPathName : node.name;
    }
    return ''; // was N/A, but making it just BLANK, which is invalid cat
  };

  isTransfer = (node) => node && node.coa.type === 'ACCOUNT';


  handleRequestClose = () => {
    log.log('On Request Close...');
    this.setState({ showMenu: false });
    if (this.props.menuClose) {
      this.props.menuClose();
    }
  };

  menuOnChange = (item) => {
    if (item) {
      if (item.id === 'viewAll') {
        this.setState({ query: null, showMenu: true });
        return;
      }
      if (this.props.returnSelectionMethod) {
        // this.props.onChange({ coa: item.coa, selMethod: 'Menu' });
        this.props.onChange(item.coa);
      } else {
        this.props.onChange(item.coa);
      }
      this.handleRequestClose();
      this.setState({ query: null });
      if (this.props.menuClose) {
        this.props.menuClose();
      }
    }
  };

  renderCOAMenuNode = (coaNode) => {
    const { stType, categoriesById, accountsById, onlyL1, filterFn } = this.props;

    if (!onlyL1 && coaNode.children) {

      const menuItems = coaNode.children.map((childNode) => (
        this.renderCOAMenuNode(childNode)
      ));

      return { label: coaNode.name, value: coaNode, subMenu: menuItems };
    }

    if (coaNode.inList && (!filterFn || filterFn(coaNode.coa)) &&
      coaIncludedInList(coaNode.coa, categoriesById, accountsById, stType)) {
      return { label: coaNode.name, value: coaNode };
    }
    return { nop: true };

  };

  buildMatchedString = (match, indexOfMatch) => {
    const { theme } = this.props;
    const parentSplit = match.indexOf(":");
    if (parentSplit !== -1 && parentSplit < indexOfMatch) { // need to grey out parent
      return (
        <QTypography>
          <span style={{ color: theme.palette.text.secondary }} >{match.slice(0, parentSplit)}</span>
          <span>{match.slice(parentSplit, indexOfMatch)}</span>
          <span style={{ fontWeight: theme.typography.fontWeightMedium }} >{match.slice(indexOfMatch, indexOfMatch+this.state.query.length)}</span>
          <span>{match.slice(indexOfMatch+this.state.query.length)}</span>
        </QTypography>
      );
    }

    const index = indexOfMatch === -1 ? 0 : indexOfMatch;
    const queryLength = index + this.state.query.replace(':', ' : ').length;

    // no parent so no greying out
    return (
      <QTypography>
        {match.slice(0, index)}
        <span style={{ fontWeight: theme.typography.fontWeightMedium }}>{match.slice(index, queryLength)}</span>
        {match.slice(queryLength)}
      </QTypography>
    );
  };

  filterOptions = (options, query) => {
    let items = [];
    const lowerCasedQuery = query.toLowerCase();

    options.forEach((option) => {
      if (!option.nop && !option.isSubheader && option.value && option.value.fullPathName
        && option.label && option.value.fullPathName.toLowerCase().indexOf(query.toLowerCase()) !== -1
        && (!this.props.filterFn || this.props.filterFn(option.value.coa))) {
        const name = option.value.fullPathName.replace(':', ' : ');
        const boldIndex = name.toLowerCase().indexOf(lowerCasedQuery);
        items.push({
          label: name,
          customRender: this.buildMatchedString(name, boldIndex),
          value: option.value,
        });
      }
      if (option.subMenu) {
        items = items.concat(this.filterOptions(option.subMenu, query));
      }
    });
    return items;
  };

  dropDownClick = () => this.setState({ showMenu: !this.state.showMenu, query: null });

  handleInputFocus = (event) => {
    event.target.focus();
    event.target.select();  // automatically highlights the input value
    // this.setState({ showMenu: true });
  };

  handleQueryChange = (event) => {
    this.setState({ query: event.target.value });
  };

  handleKeyDown = (event) => {
    if (this.state.showMenu && event.key !== 'Tab' && event.key !== 'Enter') {
      event.stopPropagation();
    } else if (event.key !== 'Shift' && event.key !== 'Escape' && event.key !== 'Enter' && event.key !== 'Tab') {
      this.setState({ showMenu: !this.state.showMenu });
    } else if (event.key === 'Enter' && this.currentHover) {
      event.stopPropagation();
    } else if (event.key === 'Tab' && this.currentHover) {
      if (this.currentHover.onSelect) {
        this.currentHover.onSelect();
      } else if (this.currentHover.value.coa) {
        this.props.onChange(this.currentHover.value.coa);
      }
    } else if (event.key === 'Escape') {
      this.handleRequestClose();
    }
  };

  handleCurrentHover = (current) => {
    if (this.currentHover !== current)
      this.currentHover = current;
  };

  handleNewCategoryClick = (parentNode = null) => {
    const newCatLabel = this.state.query;
    const newCategoryClientId = uuidv4().toUpperCase();
    let type = this.props.recommendedCategoryType || CategoryTypeEnum.EXPENSE;
    if (parentNode && parentNode.coa && parentNode.coa.type === CoaTypeEnum.CATEGORY && parentNode.coa.id) {
      const parentCategory = this.props.categoriesById.get(parentNode.coa.id);
      type = parentCategory && parentCategory.type ? parentCategory.type : CategoryTypeEnum.EXPENSE;
    }
    const newCategory = mkCategory({
      clientId: newCategoryClientId,
      parentId: parentNode ? parentNode.id : '0',
      name: newCatLabel,
      type,
    });
    this.props.dispatchCreateCategoryAction(newCategory);
    this.setState({
      newCategoryClientId,
      showMenu: false,
      query: null,
      placeholder: newCatLabel,
      inProgress: true,
    });
    setTimeout(() => {
      if (this.state.newCategoryClientId === newCategoryClientId && this.state.inProgress) {
        this.setState({
          inProgress: false,
        });
      }
    }, 8000);
  };

  treeHasMainCategory = (name) => this.props.coaTree.some((coaNode) => coaNode.name && coaNode.name.toLowerCase() === name.toLowerCase());

  optionHasSubCategory = (parent, label) => parent.subMenu && parent.subMenu.some((option) => option.label && option.label.toLowerCase() === label.toLowerCase());

  render() {
    const { state } = this;
    const { editable, clickable, classNameWhenNotEditable, name, inputStyle, margin, numPopularCats, header,
      autoFocus, fontSize, popularCats, variant, filterFn, InputProps, label, textFieldProps, theme, width } = this.props;
    const toolTipTitle = this.state.isTransfer ? `[${this.state.tfValue}]` : this.state.tfValue;

    let menuItems = [];
    let selectedMenuItem;

    const popularCatsFiltered = filterFn ? popularCats.filter((x) => filterFn(x.coa)) : popularCats;

    if (!this.state.query && popularCatsFiltered && popularCatsFiltered.size > 0) {

      menuItems = [];

      if (numPopularCats > 0) {
        menuItems.push(
          {
            isSubheader: true,
            label: 'Most Used Categories',
            backgroundColor: '#fafaf9',
          },
        );
      }
      popularCatsFiltered.slice(0, numPopularCats).forEach((catRecord, index) => {
        menuItems.push({
          label: getCoaString(catRecord.coa, true),
          value: catRecord,
          subIndent: true,
          divider: index === (popularCatsFiltered.slice(0, numPopularCats).size - 1),
          backgroundColor: '#fafaf9',
        });
      });
    }

    if (editable) {
      menuItems = menuItems.concat([{ isSubheader: true, label: 'All Categories' }]);
      menuItems = menuItems.concat(this.props.coaTree.map((coaNode) =>
        (this.props.allowNone || coaNode.coa.type !== 'NONE') &&
        (!filterFn || filterFn(coaNode.coa)) ? this.renderCOAMenuNode(coaNode) : null).toJS());
    }
    menuItems = menuItems.filter((x) => x !== null);

    if (this.state.query) {
      let addCatOption = this.props.createEnabled && !this.treeHasMainCategory(this.state.query);
      if (addCatOption) {
        addCatOption = {
          customRender: (<QTypography>Create<span style={{ fontWeight: theme.typography.fontWeightMedium }} >{` "${this.state.query}"`}</span></QTypography>),
          onSelect: () => {},
          value: 'create-category-bucket',
          label: 'create-category',
          subMenu: [
            {
              label: 'Main Category',
              value: 'create-parent-category',
              onSelect: this.handleNewCategoryClick,
            },
            {
              label: 'Subcategory of',
              value: 'create-child-category',
              onSelect: () => {},
              subMenu: this.props.coaTree
                .filter((coaNode) => coaNode.coa.type === CoaTypeEnum.CATEGORY)
                .map((coaNode) => {
                  const menuNode = this.renderCOAMenuNode(coaNode);
                  return {
                    ...menuNode,
                    subMenu: null,
                    onSelect: () => this.handleNewCategoryClick(menuNode.value),
                  };
                }),
            },
          ],
        };
      }

      menuItems = this.filterOptions(menuItems, this.state.query);

      if (menuItems && menuItems.length) {
        selectedMenuItem = menuItems[0];
      } else if (addCatOption) {
        selectedMenuItem = addCatOption;
      }

      if (addCatOption) {
        menuItems.unshift(addCatOption);
      }

      menuItems.push({
        label: 'See All Categories',
        value: 'see-all',
        onSelect: () => {
          this.setState({ query: null });
          if (this.inputRef) {
            this.inputRef.focus();
            this.inputRef.select();
          }
        },
      });
    }

    const flipIcon = this.state.showMenu || this.state.query !== null;

    return (
      <>
        {editable &&
          <div
            id={`category-field-wrapper-${name}-${this.props.id}`}
            ref={(x) => { this.fieldRef = x; }}
            style={{...this.props.style, width}}
            className={this.props.classes.root}
          >
            <TextField
              disabled={state.inProgress}
              onClick={this.dropDownClick}
              {...textFieldProps }
              className={this.props.className || ''}
              label={label}
              value={this.state.query !== null ? this.state.query : this.state.placeholder || this.state.tfValue || ''}
              onChange={this.handleQueryChange}
              onKeyDown={this.handleKeyDown}
              onFocus={this.handleInputFocus}
              onBlur={this.props.disableOnBlur && this.state.showMenu ? undefined : this.props.onBlur}
              autoFocus={autoFocus}
              style={{ width: '100%' }}
              error={this.props.error}
              name={name}
              margin={margin}
              autoComplete="off"
              InputProps={{
                ...InputProps,
                disableUnderline: this.props.disableUnderline,
                id: "category_list_input",
                endAdornment:
                  <>
                    {state.inProgress &&  // dont take up precious space for a 5% use case (on create cat)
                      <CircularProgress
                        size={16}
                        style={{ visibility: state.inProgress ? 'visible' : 'hidden' }}
                      />
                    }
                    <QIconButton
                      id="category_list_dropdown"
                      disabled={state.inProgress}
                      style={{color: theme.palette.grey.level6, cursor: 'pointer', fontSize: '23px', opacity: flipIcon && 1}}
                      aria-label="Open Category List"
                      focusRipple
                      IconComponent={flipIcon ? ExpandLessRoundedIcon : ExpandMoreRoundedIcon}
                      onClick={this.dropDownClick}
                      size="small-no-padding"
                      TooltipProps={{enterDelay: 10}}
                      tabIndex={-1}
                    />
                  </>,
                style: {
                  paddingTop: 0,
                  paddingBottom: 0,
                  height: isIe ? 27 : 24, // ie11 needs 27
                  lineHeight: '22px',
                  fontSize,
                  color: (state.query && state.query !== state.tfValue) || (state.placeholder && state.placeholder !== state.tfValue) ?
                    theme.palette.text.secondary : undefined,
                  ...InputProps ? InputProps.style : {},
                },
              }}
              // eslint-disable-next-line react/jsx-no-duplicate-props
              inputProps={{
                className: inputStyle || '',
              }}
              inputRef={(x) => {
                if (this.props.inputRef) {
                  this.props.inputRef(x);
                }
                this.inputRef = x;
              }}
              // placeholder="Category"
            />
            {this.state.showMenu &&
              <div style={{ margin: 'auto' }}>
                <NestedQMenu
                  anchorEl={this.fieldRef}
                  header={header}
                  name="catmenu"
                  options={menuItems}
                  selectedOption={selectedMenuItem}
                  onChange={this.menuOnChange}
                  open={this.state.showMenu || this.state.query !== null}
                  onClose={() => {
                    this.setState({ query: null });
                    this.handleRequestClose();
                    this.props.disableOnBlur && this.props.onBlur({relatedTarget: 'categoryfield'});
                  }}
                  currentHover={this.handleCurrentHover}
                />
              </div>
            }
          </div>
        }
        {!editable &&
          <QTip
            wrapOnly
            title={this.props.tooltip ? toolTipTitle : null}
          >
            <QTypography
              variant={variant}
              clickable={clickable}
              className={classNameWhenNotEditable}
            >
              {this.state.isTransfer ? `[${this.state.tfValue}]` : this.state.tfValue}
            </QTypography>
          </QTip>
        }
      </>
    );
  }
}

CategoryFieldEditable.propTypes = {
  theme: PropTypes.object,
  style: PropTypes.object,
  // props from parent
  width: PropTypes.string,
  variant: PropTypes.string,
  editable: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.object,
  initialFocus: PropTypes.bool,
  name: PropTypes.string,
  id: PropTypes.string,
  clickable: PropTypes.bool,
  returnSelectionMethod: PropTypes.bool,
  longCats: PropTypes.bool,
  onlyL1: PropTypes.bool,
  allowBlank: PropTypes.bool,
  allowNone: PropTypes.bool,
  classNameWhenNotEditable: PropTypes.string,
  tooltip: PropTypes.bool, // show a tooltip on static value?
  disableUnderline: PropTypes.bool,
  autoFocus: PropTypes.bool,
  history: PropTypes.object,
  fontSize: PropTypes.string,
  label: PropTypes.string,
  margin: PropTypes.string,
  inputRef: PropTypes.func,
  onBlur: PropTypes.func,
  error: PropTypes.bool,
  createEnabled: PropTypes.bool,
  recommendedCategoryType: PropTypes.string,
  filterFn: PropTypes.func,
  inputStyle: PropTypes.string,
  transferOnly: PropTypes.bool,
  stType: PropTypes.string,
  InputProps: PropTypes.object,
  textFieldProps: PropTypes.object,
  className: PropTypes.string,
  numPopularCats: PropTypes.number,
  openMenu: PropTypes.bool,
  disableOnBlur: PropTypes.bool,
  classes: PropTypes.object,
  header: PropTypes.object,
  menuClose: PropTypes.func,

  // props from redux
  coaTree: PropTypes.object,
  coaNodesById: PropTypes.object,
  categoriesById: PropTypes.object,
  accountsById: PropTypes.object,
  popularCats: PropTypes.object,
  dispatchCreateCategoryAction: PropTypes.func,
};

CategoryFieldEditable.defaultProps = {
  variant: 'body2',
  transferOnly: false,
  numPopularCats: 5,
  width: '100%',
};

function mapStateToProps(state, ownProps) {
  return {
    coaTree: ownProps.transferOnly ? getTransferCOATree(state) : getChartOfAccountsTree(state, ownProps),
    categoriesById: getCategoriesById(state),
    accountsById: getAccountsById(state),
    popularCats: getMostPopularCatsByAccountId(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchCreateCategoryAction: (data) => dispatch(createCategory(data, { undo: { userMessage: 'Category created.' } })),
  };
}

// note: order-matters - props flow from top to bottom
export default compose(withStyles({}, { withTheme: true }))(withRouter(connect(mapStateToProps, mapDispatchToProps)(CategoryFieldEditable)));
